module.exports = __webpack_public_path__ + "img/9b7b636.jpg";